import React from 'react'
// import { useParams } from 'react-router-dom';
import NavWidget from '../../widget/Nav/NavWidget'
import DashboardHome from './pages/home/home';
import SidebarWidget from '../../widget/SidebarWidget/SidebarWidget';




function dashboard() {
// const accesTokenValue = Cookies.get('userAccessToken');
// const currentEstate = Cookies.get('userAccessToken');


  return (
    <div >
        <NavWidget/>
        <div className='row' >
            <div className='col s12 l2 transparent hide-on-med-and-down'>
                <SidebarWidget/>
            </div>
            <div className='col s12 l10 '
                style={{
                    maxheight:"1300px",
                    overflow: "auto !important",
                }}
            >
                <div className='row p-2'>
                    <div className='col s12 '>
                        <DashboardHome />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default dashboard